module.exports = __webpack_public_path__ + "static/media/SuggestedProfilesPlaceholder.698274f7.png";